<div class="row py-2">
    @for (crumb of crumbs(); track crumb.name; let index = $index; let count = $count) {
        @if (crumb.route) {
            <div class="col-auto">
                <a [routerLink]="'/' + crumb.route">{{crumb.name}}</a>
            </div>
        } @else {
            <div class="col-auto">
                <span>{{crumb.name}}</span>
            </div>
        }
        @if (count >= 2 && index < count - 1) {
            <div class="col-auto px-0">
                <i class="fas fa-chevron-right"></i>
            </div>
        }
    }
</div>
